import React, { useEffect, useState } from 'react';
import { apiService } from '../../domain/platform/apiService';

interface ConnectionView {
  id: string;
  name: string;
  type: 'google_sheets' | 'postgres';
  status: 'active' | 'inactive';
  createdAt: string;
}

const ConnectionsPanel: React.FC = () => {
  const [connections, setConnections] = useState<ConnectionView[]>([]);
  const [name, setName] = useState('Primary Sheets');
  const [type, setType] = useState<'google_sheets' | 'postgres'>('google_sheets');
  const [saving, setSaving] = useState(false);

  const load = async () => {
    const current = await apiService.listConnections();
    setConnections(current);
  };

  useEffect(() => {
    load();
  }, []);

  const createConnection = async (event: React.FormEvent) => {
    event.preventDefault();
    setSaving(true);
    await apiService.createConnection({ name, type });
    await load();
    setSaving(false);
  };

  return (
    <section className="panel-surface coming-soon-panel">
      <h2>Connections</h2>
      <p>Register upstream data sources for scheduled refresh pipelines.</p>

      <form onSubmit={createConnection} style={{ marginTop: '16px', display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Connection name" />
        <select value={type} onChange={(e) => setType(e.target.value as 'google_sheets' | 'postgres')}>
          <option value="google_sheets">Google Sheets</option>
          <option value="postgres">Postgres</option>
        </select>
        <button type="submit" className="primary-button" disabled={saving}>{saving ? 'Saving...' : 'Add Connection'}</button>
      </form>

      <div style={{ marginTop: '16px' }}>
        {connections.map((connection) => (
          <div key={connection.id} className="quality-operation">
            <strong>{connection.name}</strong> ({connection.type}) - {connection.status}
          </div>
        ))}
        {connections.length === 0 && <div className="muted">No connections configured yet.</div>}
      </div>
    </section>
  );
};

export default ConnectionsPanel;
